import _structuredClone from '@ungap/structured-clone';
import * as caniuse from './caniuse';
const clone = caniuse.structuredClone() ? globalThis.structuredClone : _structuredClone;
export function deepClone(obj) {
    return clone(obj);
}
